import { FetchSuccess, FetchError } from "../types/FetchTypes";

// Create a dummy success promise to help make fetch logic testable
export function mockSuccessResponse<T>(body: T): Promise<FetchSuccess<T>> {
    return new Promise(resolve => resolve({
        ok: true,
        status: 200,
        getValue(): Promise<T> {
            return new Promise(resolve => resolve(body));
        }
    }));
}

export function parseResponse<TSuccess, TFailure>(response: Response): FetchSuccess<TSuccess> | FetchError<TFailure> {
    return {
        ok: response.ok,
        status: response.status,
        async getValue() {
            const result = await response.text();
            return result.length ? JSON.parse(result) : null;
        }
    };
};

export async function post<T>(route: string, postBodyData: any): Promise<FetchSuccess<T | null> | FetchError> {
    const result = await fetch(route, {
        method: 'POST',
        cache: 'no-cache',
        headers:{
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(postBodyData)
    });
    return parseResponse(result);
}